// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-registration-page {
  margin: 0 auto;
  max-width: 1100px;
}

.device-registration-intro {
  color: #4b5563;
  margin-bottom: 1rem;
}

.device-registration-modes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.device-registration-card {
  margin-bottom: 1.5rem;
}

.device-registration-json {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  min-height: 75vh;
  overflow: hidden;
}

.device-registration-json-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.device-registration-inline-lists {
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
}

.device-registration-repeatable {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 1rem;
}

.device-registration-repeatable-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.device-registration-icon-button {
  align-items: center;
  display: inline-flex;
  flex: 0 0 2rem;
  height: 2rem;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 2rem;
}

.device-registration-repeatable-header h3 {
  font-size: 1rem;
  margin: 0;
}

.device-registration-repeatable-row {
  align-items: center;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
}

.device-registration-empty {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0;
}

.device-registration-actions {
  display: flex;
  gap: 0.75rem;
}

@media (max-width: 767.98px) {
  .device-registration-repeatable-row {
    align-items: stretch;
    flex-direction: column;
  }

  .device-registration-repeatable-row .device-registration-icon-button {
    align-self: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DeviceRegistration/DeviceRegistration.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".device-registration-page {\n  margin: 0 auto;\n  max-width: 1100px;\n}\n\n.device-registration-intro {\n  color: #4b5563;\n  margin-bottom: 1rem;\n}\n\n.device-registration-modes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.device-registration-card {\n  margin-bottom: 1.5rem;\n}\n\n.device-registration-json {\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  min-height: 75vh;\n  overflow: hidden;\n}\n\n.device-registration-json-actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.device-registration-inline-lists {\n  display: grid;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.device-registration-repeatable {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.device-registration-repeatable-header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n\n.device-registration-icon-button {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 2rem;\n  height: 2rem;\n  justify-content: center;\n  line-height: 1;\n  padding: 0;\n  width: 2rem;\n}\n\n.device-registration-repeatable-header h3 {\n  font-size: 1rem;\n  margin: 0;\n}\n\n.device-registration-repeatable-row {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 0.375rem;\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n}\n\n.device-registration-empty {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-bottom: 0;\n}\n\n.device-registration-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n@media (max-width: 767.98px) {\n  .device-registration-repeatable-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .device-registration-repeatable-row .device-registration-icon-button {\n    align-self: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
